module.exports = "//cdn.mxpnl.com/static/asset-cache/8bccb178b2c26518affa05793729966a/iron/common/assets/images/query/filter.svg";